"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToCountry = exports.Country = void 0;
var Country;
(function (Country) {
    Country["dk"] = "dk";
    Country["eu"] = "eu";
    Country["is"] = "is";
    Country["gb"] = "gb";
    Country["us"] = "us";
})(Country || (exports.Country = Country = {}));
var stringToCountry = function (value) {
    if (value) {
        var country = value.toLowerCase();
        if (country in Country) {
            return country;
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
};
exports.stringToCountry = stringToCountry;
//# sourceMappingURL=Country.js.map